module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 120 40",
      url: __webpack_public_path__ + "svg-sprite-84e6ba0859b67d2a822c8ad28bb7a5bc.svg#appstore",
      toString: function () {
        return this.url;
      }
    }